package devxertech.com.pages.contactSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.backgroundPosition
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.Page
import devxertech.com.seo.PageMetadataForCurrentRoute
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.icons.fa.FaFacebook
import com.varabyte.kobweb.silk.components.icons.fa.FaLinkedin
import com.varabyte.kobweb.silk.components.icons.fa.FaLocationDot
import com.varabyte.kobweb.silk.components.icons.fa.FaPhone
import com.varabyte.kobweb.silk.components.icons.fa.FaSquareInstagram
import com.varabyte.kobweb.silk.components.icons.fa.FaXTwitter
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.layout.VerticalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonButton
import devxertech.com.component.CustomTextInput
import devxertech.com.component.ResizableTextAreaField
import devxertech.com.component.openLinkInNewTab
import devxertech.com.models.SendEmailPayload
import devxertech.com.models.SendEmailResponse
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.section.DesktopNavigationAnchor
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.section.SideBar
import devxertech.com.section.TopBar
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.APIMETHODS
import devxertech.com.utils.Constants
import devxertech.com.utils.Grecaptcha
import devxertech.com.utils.loadRecaptcha
import devxertech.com.utils.Res
import devxertech.com.utils.httpJsonRequest
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Iframe
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text
import com.varabyte.kobweb.compose.ui.toAttrs


@Page("/contact-us")
@Composable
fun ContactUsSection() {
    PageMetadataForCurrentRoute()
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val ctx = rememberPageContext()
    val sitePalette = ColorMode.current.toSitePalette()
    var emailInput by remember { mutableStateOf("") }
    var nameInput by remember { mutableStateOf("") }
    var contactInput by remember { mutableStateOf("") }
    var subjectInput by remember { mutableStateOf("") }
    var textAreaInput by remember { mutableStateOf("") }
    var isSideMenuOpen by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }

    var nameError by remember { mutableStateOf<String?>(null) }
    var emailError by remember { mutableStateOf<String?>(null) }
    var contactError by remember { mutableStateOf<String?>(null) }
    var subjectError by remember { mutableStateOf<String?>(null) }
    var messageError by remember { mutableStateOf<String?>(null) }

    var countries by remember { mutableStateOf<List<Country>>(emptyList()) }
    var selectedCountry by remember { mutableStateOf<Country?>(null) }

    LaunchedEffect(Unit) {
        val all = fetchCountries()
        countries = all

        // auto detect user country
        val iso = detectUserCountryISO()
        selectedCountry = selectedCountry ?: all.firstOrNull { it.iso == iso } ?: all.firstOrNull()
    }

    fun validateForm(): Boolean {

        // Clear all previous errors
        nameError = null
        emailError = null
        contactError = null
        subjectError = null
        messageError = null

        if (nameInput.isBlank()) {
            nameError = "Name is required"
            return false
        }

        if (emailInput.isBlank()) {
            emailError = "Email is required"
            return false
        }

        if (!emailInput.matches(Regex("^[A-Za-z0-9+_.-]+@(.+)$"))) {
            emailError = "Invalid email address"
            return false
        }

        if (contactInput.isBlank()) {
            contactError = "Contact number is required"
            return false
        }

        if (contactInput.length < 7) {
            contactError = "Invalid contact number"
            return false
        }

        if (subjectInput.isBlank()) {
            subjectError = "Subject is required"
            return false
        }

        if (textAreaInput.isBlank()) {
            messageError = "Message is required"
            return false
        }

        return true // all fields valid
    }


    if (isSideMenuOpen || breakpoint < Breakpoint.XL) {
        SideBar(breakpoint = breakpoint, isOpen = isSideMenuOpen, onClose = { isSideMenuOpen = false }, showExtraText = true)
    }

    val contactHeadingModifier = Modifier.fontSize(if (breakpoint > Breakpoint.MD) 18.px else 16.px)
        .fontWeight(FontWeight.Bold)
        .fontFamily(Constants.FONT_FAMILY).lineHeight(30.px).padding(top = 15.px)
        .color(sitePalette.commonSecondaryButtonColor.rgb)
    val contactTextModifier = Modifier.fontSize(if (breakpoint > Breakpoint.MD) 16.px else 14.px)
        .fontWeight(FontWeight.Medium)
        .fontFamily(Constants.FONT_FAMILY).lineHeight(23.px).margin(bottom = 10.px)
        .color(sitePalette.contactText.rgb).whiteSpace(whiteSpace = WhiteSpace.PreWrap)
    val placeholderModifier = Modifier.fontSize(14.px).fontWeight(FontWeight.Medium)
        .fontFamily(Constants.FONT_FAMILY).color(sitePalette.contactText.rgb)
        .padding(left = 20.px)

    Column(
        modifier = Modifier.fillMaxWidth()
            .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb),
    ) {
        Box(
            modifier = Modifier.fillMaxWidth()
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(
                        if (breakpoint > Breakpoint.MD) Constants.CONTACT_SEC_HEIGHT.px
                        else if (breakpoint == Breakpoint.MD) 365.px else 250.px
                    )
                    .backgroundImage(
                        linearGradient(
                            LinearGradient.Direction.ToRight,
                            sitePalette.contactUsHeaderOne.rgb, sitePalette.contactUsHeaderTwo.rgb
                        )
                    ).zIndex(1)
            ) {
                Image(
                    src = if (breakpoint > Breakpoint.MD) Res.Image.contact_Banner
                    else if (breakpoint == Breakpoint.MD) Res.Image.contact_Banner
                    else Res.Image.contact_Banner,
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(
                            if (breakpoint > Breakpoint.MD) 500.px
                            else if (breakpoint == Breakpoint.MD) 285.px
                            else 160.px
                        )
//                        .objectFit(ObjectFit.Cover)
                        .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
                        .margin(top = if (breakpoint > Breakpoint.MD) 25.px else 55.px),
                    description = ""
                )

                Column(
                    modifier = Modifier.fillMaxSize().zIndex(3)
                )
                {
                    TopBar(
                        breakpoint = breakpoint,
                        onMenuClick = { isSideMenuOpen = true },
                        contactModification = true
                    )
                    Column(
                        modifier = Modifier.fillMaxSize(),
                    ) {
                        Column(
                            modifier = Modifier.fillMaxSize()
                                .margin(top = if (breakpoint < Breakpoint.MD) 0.px else 0.px)
                                .align(Alignment.CenterHorizontally),
                            verticalArrangement = Arrangement.Center,
                            horizontalAlignment = Alignment.CenterHorizontally
                        )
                        {
                            H1(attrs = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(if (breakpoint > Breakpoint.MD) 65.px else if (breakpoint == Breakpoint.MD) 50.px else if (window.screen.width < 375) 25.px else 30.px)
                                    .color(sitePalette.bodyBackgroundSecondary.rgb)
                                    .fontWeight(FontWeight.ExtraBold)
                                    .lineHeight(if (breakpoint < Breakpoint.MD) 50.px else 71.px)
                                    .margin(top = if (breakpoint > Breakpoint.MD) 45.px else 25.px)
                                    .toAttrs()) { Text("Contact Us") }
                            SpanText(
                                text = "Fueling your brand's path to success",
                                modifier = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(if (breakpoint > Breakpoint.MD) 35.px else if (breakpoint == Breakpoint.MD) 25.px else if (window.screen.width < 375) 14.px else 16.px)
                                    .color(sitePalette.bodyBackgroundSecondary.rgb)
                                    .fontWeight(FontWeight.Medium)
                                    .lineHeight(if (breakpoint > Breakpoint.MD) 37.4.px else 17.px)
                                    .letterSpacing(0.5.px)
                                    .margin(top = if (breakpoint < Breakpoint.MD) 0.px else 15.px)
                            )
                        }
                    }
                }
            }
        }
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 0.px)
                .margin(bottom = if (breakpoint > Breakpoint.MD) 20.px else 30.px),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (breakpoint > Breakpoint.MD) {
                Box(
                    modifier = Modifier,
                    contentAlignment = Alignment.Center
                ) {
                    Image(
                        modifier = Modifier.margin(left = 100.px),
                        src = Res.Image.contact_arrow,
                        description = ""
                    )
                    Row(
                        modifier = Modifier
                            .width(201.px)
                            .margin(left = 130.px)
                            .padding(bottom = 8.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceAround
                    )
                    {
                        DesktopNavigationAnchor("/", Modifier) {
                            SpanText(
                                text = "Home",
                                modifier = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontWeight(FontWeight.Medium)
                                    .lineHeight(37.4.px)
                                    .fontSize(20.px)
                                    .color(sitePalette.commonSecondaryButtonColor.rgb)
                                    .cursor(Cursor.Pointer)
                            )
                        }
                        VerticalDivider(
                            modifier = Modifier
                                .width(1.px)
                                .backgroundColor(sitePalette.commonSecondaryButtonColor.rgb)
                                .height(20.px)
                        )
                        SpanText(
                            text = "Contact Us",
                            modifier = Modifier
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontWeight(FontWeight.Medium)
                                .lineHeight(37.4.px)
                                .fontSize(20.px)
                                .color(sitePalette.primary.rgb)
                        )
                    }
                }
            }
        }
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = if (breakpoint >= Breakpoint.MD && breakpoint <= Breakpoint.LG) 50.px else 30.px)
                .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb),
            contentAlignment = Alignment.Center
        ) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    SpanText(
                        text = "Let's connect",
                        modifier = Modifier
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(if (breakpoint >= Breakpoint.MD) 18.px else 15.px)
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontWeight(FontWeight.Medium)
                            .lineHeight(15.4.px)
                            .textTransform(TextTransform.Uppercase)
                            .padding(bottom = 13.px)
                            .textTransform(TextTransform.Uppercase)
                    )
                    H2(attrs = { style { property("display", "flex"); property("margin", "0") } }) { Row(
                        modifier = Modifier.flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        SpanText(
                            text = " We love to hear",
                            modifier = Modifier
                                .fontFamily(Constants.ROBOTO_FONT)
                                .fontSize(if (breakpoint >= Breakpoint.MD) 35.px else 22.px)
                                .color(sitePalette.primary.rgb)
                                .fontWeight(FontWeight.ExtraBold)
                                .lineHeight(if (breakpoint >= Breakpoint.MD) 37.4.px else 32.px)
                                .letterSpacing(0.5.px)
                                .textTransform(TextTransform.Uppercase)
                        )
                        SpanText(
                            text = " what you have to share!",
                            modifier = Modifier
                                .fontFamily(Constants.ROBOTO_FONT)
                                .fontSize(if (breakpoint >= Breakpoint.MD) 35.px else 22.px)
                                .color(sitePalette.commonSecondaryButtonColor.rgb)
                                .fontWeight(FontWeight.ExtraBold)
                                .lineHeight(if (breakpoint >= Breakpoint.MD) 37.4.px else 32.px)
                                .letterSpacing(0.5.px)
                                .textTransform(TextTransform.Uppercase)
                        )
                    } }
                }

//                             Main Row
                Row(
                    modifier = Modifier.fillMaxWidth(if (breakpoint == Breakpoint.LG) 1024.px else if (breakpoint > Breakpoint.MD) 1434.px else if (window.screen.width < 375) 320.px else 100.percent)
                        .margin(topBottom = if (breakpoint > Breakpoint.MD) 60.px else 60.px)
                        .borderRadius(14.px)
                        .then(
                            if (breakpoint > Breakpoint.MD) Modifier.boxShadow(
                                blurRadius = 16.8.px,
                                offsetX = 0.px,
                                offsetY = 4.px,
                                spreadRadius = 0.px,
                                color = sitePalette.specialButtonBorderColor.rgb
                            ) else Modifier
                        )
                        .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    // Left Content
                    Column(
                        modifier = Modifier
                            .fillMaxWidth(if (breakpoint == Breakpoint.LG) 38.percent else if (breakpoint > Breakpoint.MD) 38.percent else 100.percent)
                            .padding(bottom = 30.px)
                            .borderRadius(
                                topLeft = if (breakpoint > Breakpoint.MD) 14.px else 0.px,
                                bottomLeft = if (breakpoint > Breakpoint.MD) 14.px else 0.px
                            )
                            .backgroundColor(sitePalette.contactLeft.rgb),
                        horizontalAlignment = Alignment.CenterHorizontally
                    )
                    {
                        Row(
                            modifier = Modifier.fillMaxWidth().height(90.px)
                                .padding(left = if (breakpoint == Breakpoint.LG) 50.px else if (window.screen.width < 375) 60.px else 70.px)
                                .margin(top = 40.px),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Start
                        ) {
                            Box(
                                modifier = Modifier.size(if (breakpoint > Breakpoint.MD) 60.px else 45.px)
                                    .borderRadius(100.px)
                                    .backgroundColor(sitePalette.primary.rgb)
                                    .border(
                                        width = 1.px,
                                        style = LineStyle.Solid,
                                        color = sitePalette.primary.rgb
                                    ),
                                contentAlignment = Alignment.Center
                            ) {
                                FaEnvelope(
                                    modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                    size = IconSize.XL,
                                    style = IconStyle.FILLED
                                )
                            }
                            Row(
                                modifier = Modifier.padding(left = 35.px),
                                horizontalArrangement = Arrangement.Center
                            ) {
                                Column(
                                    modifier = Modifier,
                                    verticalArrangement = Arrangement.Center
                                ) {
                                    SpanText(text = "Email Us", modifier = contactHeadingModifier)
                                    SpanText(
                                        text = "info@devxertech.com",
                                        modifier = contactTextModifier
                                    )
                                }
                            }
                        }
                        Row(
                            modifier = Modifier.fillMaxWidth().height(90.px)
                                .padding(left = if (breakpoint == Breakpoint.LG) 50.px else if (window.screen.width < 375) 60.px else 70.px)
                                .margin(top = if (breakpoint == Breakpoint.LG) 30.px else 20.px),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Start
                        ) {
                            Box(
                                modifier = Modifier.size(if (breakpoint > Breakpoint.MD) 60.px else 45.px)
                                    .borderRadius(100.px)
                                    .backgroundColor(sitePalette.primary.rgb)
                                    .border(
                                        width = 1.px,
                                        style = LineStyle.Solid,
                                        color = sitePalette.primary.rgb
                                    ),
                                contentAlignment = Alignment.Center
                            ) {
                                FaPhone(
                                    modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                    size = IconSize.XL
                                )
                            }
                            Row(
                                modifier = Modifier.padding(left = 35.px),
                                horizontalArrangement = Arrangement.Center
                            ) {
                                Column(
                                    modifier = Modifier,
                                    verticalArrangement = Arrangement.Center
                                ) {
                                    SpanText(text = "Call Us", modifier = contactHeadingModifier)
                                    SpanText(
                                        text = "+92-305-741-8989",
                                        modifier = contactTextModifier
                                    )
                                }
                            }
                        }
                        Row(
                            modifier = Modifier.fillMaxWidth().height(90.px)
                                .padding(left = if (breakpoint == Breakpoint.LG) 50.px else if (window.screen.width < 375) 60.px else 70.px)
                                .margin(top = 20.px),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Start
                        ) {
                            Box(
                                modifier = Modifier.size(if (breakpoint > Breakpoint.MD) 60.px else 45.px)
                                    .borderRadius(100.px)
                                    .backgroundColor(sitePalette.primary.rgb)
                                    .border(
                                        width = 1.px,
                                        style = LineStyle.Solid,
                                        color = sitePalette.primary.rgb
                                    ),
                                contentAlignment = Alignment.Center
                            ) {
                                FaLocationDot(
                                    modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                    size = IconSize.XL
                                )
                            }
                            Row(
                                modifier = Modifier.padding(left = if (breakpoint == Breakpoint.LG) 40.px else 35.px),
                                horizontalArrangement = Arrangement.Center
                            ) {
                                Column(
                                    modifier = Modifier,
                                    verticalArrangement = Arrangement.Center
                                ) {
                                    SpanText(
                                        text = "Head Office",
                                        modifier = contactHeadingModifier
                                    )
                                    SpanText(
                                        text = "101-P, Gulberg II, Lahore\n" +
                                                "Punjab, Pakistan",
                                        modifier = contactTextModifier
                                    )
                                }
                            }
                        }
                        HorizontalDivider(
                            modifier = Modifier.color(sitePalette.primary.rgb)
                                .width(
                                    when {
                                        breakpoint == Breakpoint.LG -> 300.px
                                        breakpoint > Breakpoint.MD -> 75.percent
                                        breakpoint == Breakpoint.MD -> 400.px
                                        window.screen.width < 375 -> 300.px
                                        else -> 323.px
                                    }
                                )
                                .margin(
                                    top = 40.px,
                                    right = if (breakpoint == Breakpoint.MD) 150.px else 0.px
                                )
                        )
                        Column(
                            modifier = Modifier.fillMaxWidth(if (breakpoint > Breakpoint.MD) 100.percent else if (window.screen.width < 375) 320.px else 100.percent)
                                .padding(left = if (breakpoint == Breakpoint.LG) 170.px else if (window.screen.width < 375) 40.px else 70.px)
                                .margin(left = 0.px),
                        ) {
                            SpanText(
                                text = "Follow Our Social Media",
                                modifier = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(if (breakpoint >= Breakpoint.MD) 25.px else if (window.screen.width < 375) 22.px else 25.px)
                                    .color(sitePalette.commonSecondaryButtonColor.rgb)
                                    .fontWeight(500)
                                    .lineHeight(86.px)
                            )
                            Row(modifier = Modifier) {
                                Box(
                                    modifier = Modifier.size(43.px)
                                        .backgroundColor(sitePalette.primary.rgb)
                                        .borderRadius(100.px)
                                        .margin(right = 15.px).cursor(Cursor.Pointer)
                                        .onClick { openLinkInNewTab("https://www.linkedin.com/company/devxertech/") },
                                    contentAlignment = Alignment.Center
                                ) {
                                    FaLinkedin(
                                        modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                        size = IconSize.LG
                                    )
                                }
                                Box(
                                    modifier = Modifier.size(43.px)
                                        .backgroundColor(sitePalette.primary.rgb)
                                        .borderRadius(100.px)
                                        .margin(right = 15.px).cursor(Cursor.Pointer)
                                        .onClick { openLinkInNewTab("https://www.facebook.com/devxertech") },
                                    contentAlignment = Alignment.Center
                                ) {
                                    FaFacebook(
                                        modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                        size = IconSize.LG
                                    )
                                }
                                Box(
                                    modifier = Modifier.size(43.px)
                                        .backgroundColor(sitePalette.primary.rgb)
                                        .borderRadius(100.px)
                                        .margin(right = 15.px).cursor(Cursor.Pointer)
                                        .onClick { openLinkInNewTab("https://www.instagram.com/devxertech/") },
                                    contentAlignment = Alignment.Center
                                ) {
                                    FaSquareInstagram(
                                        modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                        size = IconSize.LG
                                    )
                                }
                                Box(
                                    modifier = Modifier.size(43.px)
                                        .backgroundColor(sitePalette.primary.rgb)
                                        .borderRadius(100.px)
                                        .margin(right = 15.px).cursor(Cursor.Pointer)
                                        .onClick { openLinkInNewTab("https://twitter.com/devxertech/status/1765689654076899787") },
                                    contentAlignment = Alignment.Center
                                ) {
                                    FaXTwitter(
                                        modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                        size = IconSize.LG
                                    )
                                }
                            }
                        }
                    }
//                Right Section
                    Column(
                        modifier = Modifier.fillMaxWidth(if (breakpoint == Breakpoint.LG) 72.percent else if (breakpoint > Breakpoint.MD) 61.percent else 100.percent)
                            .margin(left = if (breakpoint == Breakpoint.LG) (-250).px else 0.px)
                            .flexWrap(FlexWrap.Wrap),
                        verticalArrangement = Arrangement.Center,
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(
                                when {
                                    breakpoint == Breakpoint.LG -> 600.px
                                    breakpoint > Breakpoint.MD -> 622.px
                                    breakpoint == Breakpoint.MD -> 680.px
                                    breakpoint < Breakpoint.MD -> 90.percent
                                    else -> 100.percent
                                }
                            )
                                .margin(
                                    left = when {
                                        window.screen.width in 800..1024 -> 110.px
                                        window.screen.width in 400..800 -> 0.px
                                        else -> 0.px
                                    }
                                )
                                .padding(top = if (breakpoint > Breakpoint.MD) 70.px else 20.px)
                                .justifyContent(if (breakpoint < Breakpoint.MD) JustifyContent.Center else JustifyContent.SpaceBetween)
                                .flexWrap(FlexWrap.Wrap),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Column(modifier = Modifier.height(if (breakpoint < Breakpoint.MD) 105.px else 82.px)) {
                                CustomTextInput(
                                    text = nameInput,
                                    onTextChange = {
                                        nameInput = it
                                        nameError = null
                                    },
                                    isMessageInput = false,
                                    placeholder = "Name",
                                    modifier = Modifier
                                        .width(
                                            if (breakpoint == Breakpoint.LG) 290.px
                                            else if (breakpoint > Breakpoint.MD) 293.px
                                            else 301.px
                                        )
                                        .height(62.px)
                                        .margin(top = if (breakpoint > Breakpoint.MD) 0.px else 30.px),
                                    placeholderModifier = placeholderModifier
                                )
                                Box(modifier = Modifier.height(20.px)) {
                                    if (nameError != null) {
                                        SpanText(
                                            text = nameError!!,
                                            modifier = Modifier
                                                .color(sitePalette.textRedColor.rgb)
                                                .fontSize(12.px)
                                                .margin(top = 4.px)
                                        )
                                    }
                                }
                            }
                            Column(modifier = Modifier.height(if (breakpoint < Breakpoint.MD) 133.px else 84.px)) {
                                CustomTextInput(
                                    text = emailInput,
                                    onTextChange = {
                                        emailInput = it
                                        emailError = null
                                    },
                                    isMessageInput = false,
                                    placeholder = "Email",
                                    modifier = Modifier.width(if (breakpoint == Breakpoint.LG) 260.px else if (breakpoint > Breakpoint.MD) 293.px else 301.px)
                                        .height(62.px),
                                    placeholderModifier = placeholderModifier
                                )
                                Box(modifier = Modifier.height(20.px)) {
                                    if (emailError != null) {
                                        SpanText(
                                            text = emailError!!,
                                            modifier = Modifier
                                                .color(sitePalette.textRedColor.rgb)
                                                .fontSize(12.px)
                                                .margin(top = 4.px)
                                        )
                                    }
                                }
                            }
                        }
                        Row(
                            modifier = Modifier.fillMaxWidth(
                                when {
                                    breakpoint == Breakpoint.LG -> 600.px
                                    breakpoint > Breakpoint.MD -> 622.px
                                    breakpoint == Breakpoint.MD -> 680.px
                                    breakpoint < Breakpoint.MD -> 90.percent
                                    else -> 100.percent
                                }
                            )
                                .justifyContent(if (breakpoint < Breakpoint.MD) JustifyContent.Center else JustifyContent.SpaceBetween)
                                .flexWrap(FlexWrap.Wrap)
                                .margin(top = if (breakpoint > Breakpoint.MD) 0.px else 32.px)
                                .padding(top = if (breakpoint > Breakpoint.MD) 30.px else 0.px)
                                .margin(
                                    left = when {
                                        window.screen.width in 800..1024 -> 110.px
                                        else -> 0.px
                                    }
                                ),
                            horizontalArrangement = Arrangement.SpaceBetween,
                        ) {
                            Column(
                                modifier = Modifier
                                    .height(if (breakpoint < Breakpoint.MD) 80.px else 82.px),
                                horizontalAlignment = Alignment.CenterHorizontally

                            ) {
                                PhoneFieldWithFlagDropdown(
                                    width = (if (breakpoint == Breakpoint.LG) 290.px else if (breakpoint > Breakpoint.MD) 293.px else 301.px),
                                    countries = countries,
                                    selectedCountry = selectedCountry,
                                    onCountryChange = { selectedCountry = it },
                                    phone = contactInput,
                                    onPhoneChange = { contactInput = it },
                                    onError = { contactError = it }
                                )
                                Box(modifier = Modifier.fillMaxWidth().height(20.px).alignItems(
                                    com.varabyte.kobweb.compose.css.AlignItems.Start
                                ),
                                    contentAlignment = Alignment.CenterStart) {
                                    if (contactError != null) {
                                        SpanText(
                                            text = contactError!!,
                                            modifier = Modifier
                                                .color(sitePalette.textRedColor.rgb)
                                                .fontSize(12.px)
                                                .margin(top = 4.px)
                                        )
                                    }
                                }
                            }

                            Column(modifier = Modifier.height(if (breakpoint < Breakpoint.MD) 110.px else 82.px)) {
                                CustomTextInput(
                                    text = subjectInput,
                                    onTextChange = {
                                        subjectInput = it
                                        subjectError = null
                                    },
                                    isMessageInput = false,
                                    placeholder = "Subject",
                                    modifier = Modifier.width(if (breakpoint == Breakpoint.LG) 260.px else if (breakpoint > Breakpoint.MD) 293.px else 301.px)
                                        .height(62.px),
                                    placeholderModifier = placeholderModifier
                                )
                                Box(modifier = Modifier.height(20.px)) {
                                    if (subjectError != null) {
                                        SpanText(
                                            text = subjectError!!,
                                            modifier = Modifier
                                                .color(sitePalette.textRedColor.rgb)
                                                .fontSize(12.px)
                                                .margin(top = 4.px)
                                        )
                                    }
                                }
                            }
                        }
                        Row(
                            modifier = Modifier.fillMaxWidth(
                                when {
                                    breakpoint == Breakpoint.LG -> 600.px
                                    breakpoint > Breakpoint.MD -> 622.px
                                    breakpoint == Breakpoint.MD -> 680.px
                                    breakpoint < Breakpoint.MD -> 90.percent
                                    else -> 100.percent
                                }
                            )
                                .justifyContent(if (breakpoint < Breakpoint.MD) JustifyContent.Center else JustifyContent.SpaceBetween)
                                .flexWrap(FlexWrap.Wrap)
                                .margin(top = if (breakpoint > Breakpoint.MD) 0.px else 32.px)
                                .padding(top = if (breakpoint > Breakpoint.MD) 35.px else 0.px)
                                .margin(
                                    left = when {
                                        window.screen.width in 800..1024 -> 110.px
                                        else -> 0.px
                                    }
                                ),
                            horizontalArrangement = Arrangement.Start
                        ) {
                            Column(
                                modifier = Modifier.padding(top = if (breakpoint < Breakpoint.MD) 20.px else 0.px)
                                    .height(if (breakpoint < Breakpoint.MD) 110.px else 150.px)
                            ) {
                                ResizableTextAreaField(
                                    value = textAreaInput,
                                    onValueChange = {
                                        textAreaInput = it
                                        messageError = null
                                    },
                                    id = "text-area-field",
                                    width =
                                    if (breakpoint > Breakpoint.MD) 622.px
                                    else if (breakpoint == Breakpoint.LG) 600.px
                                    else if (breakpoint == Breakpoint.MD) 680.px
                                    else 301.px,
                                    height = (if (breakpoint > Breakpoint.MD || breakpoint == Breakpoint.MD) 146.px else 101.px),
                                    minHeight = 40.px,
                                    maxHeight = 150.px,
                                    placeholder = "Message",
                                    resize = true
                                )
                                if (messageError != null) {
                                    SpanText(
                                        text = messageError!!,
                                        modifier = Modifier
                                            .color(sitePalette.textRedColor.rgb)
                                            .fontSize(12.px)
                                            .margin(top = 4.px)
                                    )
                                }
                            }
                        }
                        Row(
                            modifier = Modifier.width(
                                when {
                                    window.screen.width > 1024 -> 622.px
                                    window.screen.width == 1024 -> 600.px
                                    window.screen.width in 800..1023 -> 622.px
                                    window.screen.width in 641..799 -> 90.percent
                                    window.screen.width == 425 -> 70.percent
                                    window.screen.width == 375 -> 80.percent
                                    else -> 90.percent
                                }
                            )
                                .justifyContent(if (breakpoint < Breakpoint.MD) JustifyContent.Center else JustifyContent.SpaceBetween)
                                .flexWrap(FlexWrap.Wrap)
                                .padding(top = if (breakpoint < Breakpoint.MD) 50.px else 20.px)
                                .margin(
                                    left = when {
                                        window.screen.width in 800..1024 -> 110.px
                                        window.screen.width == 768 -> 10.px
                                        else -> 0.px
                                    }
                                ),
                        ) {
                            val dialCode = selectedCountry?.dialCode ?: ""
                            val fullContact = "$dialCode $contactInput"


                            CommonButton(
                                "Send Message",
                                isLoading = isLoading,
                                onClick = {
                                    scope.launch {
                                        try {
                                            if (!validateForm()) return@launch
                                            isLoading = true

                                            loadRecaptcha().await()
                                            val token = Grecaptcha.execute(
                                                "6LcwctIqAAAAAC5mssKPIFkEoH1ibmotnFEyu9gA",
                                                js("{ action: 'contact_form' }")
                                            ).await()

                                            // 2️⃣ Build payload with token
                                            val payload = SendEmailPayload(
                                                to = "info@devxertech.com",
                                                subject = subjectInput,
                                                message = """
                                                Name: $nameInput
                                                Email: $emailInput
                                                Contact: $fullContact
                                                Message: $textAreaInput
                                                """.trimIndent(),
                                                recaptchaToken = token
                                            )

                                            // Send to backend
                                            val responseText = httpJsonRequest(
                                                url = "https://devxer.com/api/send-email",
                                                method = APIMETHODS.POST,
                                                body = Json.encodeToString(payload)
                                            )

                                            val response = responseText?.let {
                                                Json.decodeFromString<SendEmailResponse>(
                                                    it
                                                )
                                            }

                                            if (response != null) {
                                                if (response.success) {
                                                    nameInput = ""
                                                    emailInput = ""
                                                    contactInput = ""
                                                    selectedCountry = countries.firstOrNull { it.iso == "PK" || it.dialCode == "+92" }
                                                    subjectInput = ""
                                                    textAreaInput = ""
                                                    println("Contact email sent successfully")
                                                } else {
                                                    println("Failed: ${response.message}")
                                                }
                                            }

                                        } catch (e: Exception) {
                                            println("Error: ${e.message}")
                                        } finally {
                                            isLoading = false
                                        }
                                    }
                                }
                            )

                        }
                    }
                }
            }
        }
        Box(
            modifier = Modifier.fillMaxWidth()
                .height(if (breakpoint > Breakpoint.MD) 450.px else 250.px)
                .padding(topBottom = 15.px)
        ) {
            Iframe(
                attrs = {
                    attr(
                        "src",
                        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.0722588927065!2d74.34986927545113!3d31.522175274213225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3919050066930c5d%3A0x12dba2937cc3c1d7!2sDevxer%20Technologies!5e0!3m2!1sen!2s!4v1747734943191!5m2!1sen!2s&zoom=17"
                    )
                    attr("width", "100%")
                    attr("height", "100%")
                    attr("style", "border:0;")
                    attr("allowfullscreen", "")
                    attr("loading", "lazy")
                    attr("referrerpolicy", "no-referrer-when-downgrade")
                }
            )
        }

        RatingSection(breakpoint)
        HomepageFooter(breakpoint)
    }
}









